function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _check_private_redeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) {
        throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
}
function _class_apply_descriptor_get(receiver, descriptor) {
    if (descriptor.get) {
        return descriptor.get.call(receiver);
    }
    return descriptor.value;
}
function _class_apply_descriptor_set(receiver, descriptor, value) {
    if (descriptor.set) {
        descriptor.set.call(receiver, value);
    } else {
        if (!descriptor.writable) {
            throw new TypeError("attempted to set read only private field");
        }
        descriptor.value = value;
    }
}
function _class_extract_field_descriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to " + action + " private field on non-instance");
    }
    return privateMap.get(receiver);
}
function _class_private_field_get(receiver, privateMap) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "get");
    return _class_apply_descriptor_get(receiver, descriptor);
}
function _class_private_field_init(obj, privateMap, value) {
    _check_private_redeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function _class_private_field_set(receiver, privateMap, value) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "set");
    _class_apply_descriptor_set(receiver, descriptor, value);
    return value;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import * as analytics from '../../internal/analytics/analytics.client';
import { MissingSentryProjectObservabilityError } from '../../internal/common/errors';
import logErrorInDev from '../../internal/common/logErrorInDev';
import observabilityConfig from '../../internal/config';
import buildErrorScope from '../../internal/errors/utils/buildErrorScope';
import generateId from '../../internal/errors/utils/generateId';
import withSdkSignature from '../../internal/errors/utils/withSdkSignature';
import * as metrics from '../../internal/metrics/metrics.client';
import { getDefaultRpcInstance } from '../../internal/rpc/defaultRpc';
const getInitConfig = ()=>{
    // If the config is not initialized, we don't want to log an error.
    return observabilityConfig.isInitialized() ? observabilityConfig.getAll() : undefined;
};
var _id = /*#__PURE__*/ new WeakMap(), _config = /*#__PURE__*/ new WeakMap();
export class Reports {
    report(level, error, scope) {
        var _this = this;
        return _async_to_generator(function*() {
            var _class_private_field_get_errors, _class_private_field_get_errors_projects, _class_private_field_get_errors1, _class_private_field_get__internal_observability_errors, _class_private_field_get__internal_observability;
            logErrorInDev(error, level, scope);
            if ((_class_private_field_get_errors = _class_private_field_get(_this, _config).errors) === null || _class_private_field_get_errors === void 0 ? void 0 : _class_private_field_get_errors.disabled) {
                return;
            }
            if ((scope === null || scope === void 0 ? void 0 : scope.project) && !((_class_private_field_get_errors1 = _class_private_field_get(_this, _config).errors) === null || _class_private_field_get_errors1 === void 0 ? void 0 : (_class_private_field_get_errors_projects = _class_private_field_get_errors1.projects) === null || _class_private_field_get_errors_projects === void 0 ? void 0 : _class_private_field_get_errors_projects[scope.project])) {
                logErrorInDev(new MissingSentryProjectObservabilityError(scope.project));
            }
            const injectedMethod = (_class_private_field_get__internal_observability = _class_private_field_get(_this, _config)._internal_observability) === null || _class_private_field_get__internal_observability === void 0 ? void 0 : (_class_private_field_get__internal_observability_errors = _class_private_field_get__internal_observability.errors) === null || _class_private_field_get__internal_observability_errors === void 0 ? void 0 : _class_private_field_get__internal_observability_errors[level];
            if (injectedMethod) {
                const errorScope = buildErrorScope(_class_private_field_get(_this, _config), error, scope);
                injectedMethod(error, withSdkSignature(errorScope));
                if (_class_private_field_get(_this, _config)._tmp_dualReporting) {
                    // If dual reporting is enabled, just send an analytics and metrics
                    // event instead of reporting the error to sentry twice. Emitting
                    // error telemetry while dual reporting allows teams to gradually
                    // migrate their detectors/dashboards to @sail/observability before
                    // removing the polyfills.
                    _this.sendErrorTelemetry(level, errorScope.tags);
                }
                return;
            }
            var _class_private_field_get_rpc;
            const rpcClient = (_class_private_field_get_rpc = _class_private_field_get(_this, _config).rpc) !== null && _class_private_field_get_rpc !== void 0 ? _class_private_field_get_rpc : getDefaultRpcInstance().client;
            return rpcClient.call('report', level, _class_private_field_get(_this, _id), error, ...[
                scope
            ].filter(Boolean));
        })();
    }
    sendErrorTelemetry(level, tags) {
        analytics.track(_class_private_field_get(this, _config), `frontend.observability.${level}`, tags);
        metrics.increment(_class_private_field_get(this, _config), `frontend.observability.${level}`, {
            page: tags.page,
            project: tags.project
        });
    }
    constructor(config){
        var _config_errors, _config_errors1, _class_private_field_get_errors_projects, _class_private_field_get_errors;
        _class_private_field_init(this, _id, {
            writable: true,
            value: void 0
        });
        _class_private_field_init(this, _config, {
            writable: true,
            value: void 0
        });
        _define_property(this, "error", (error, scope)=>{
            return this.report('error', error, scope);
        });
        _define_property(this, "warning", (error, scope)=>{
            return this.report('warning', error, scope);
        });
        _class_private_field_set(this, _config, _object_spread({}, getInitConfig(), config));
        _class_private_field_set(this, _id, generateId(_class_private_field_get(this, _config)));
        if (((_config_errors = config.errors) === null || _config_errors === void 0 ? void 0 : _config_errors._internal_injected_methods_only) || ((_config_errors1 = config.errors) === null || _config_errors1 === void 0 ? void 0 : _config_errors1.disabled)) {
            return;
        }
        if (!((_class_private_field_get_errors = _class_private_field_get(this, _config).errors) === null || _class_private_field_get_errors === void 0 ? void 0 : (_class_private_field_get_errors_projects = _class_private_field_get_errors.projects) === null || _class_private_field_get_errors_projects === void 0 ? void 0 : _class_private_field_get_errors_projects[_class_private_field_get(this, _config).project])) {
            logErrorInDev(new MissingSentryProjectObservabilityError(_class_private_field_get(this, _config).project));
        }
        var _config_rpc;
        const rpcClient = (_config_rpc = config.rpc) !== null && _config_rpc !== void 0 ? _config_rpc : getDefaultRpcInstance().client;
        rpcClient.call('initReports', _class_private_field_get(this, _id), config);
    }
}

//# sourceMappingURL=reports.client.js.map